// extracted by mini-css-extract-plugin
var _1 = "VotePostStyle-module__minus___Aa9tF";
var _2 = "VotePostStyle-module__minus-voted___bb4ld";
var _3 = "VotePostStyle-module__minus-voted___bb4ld";
var _4 = "VotePostStyle-module__plus___wqYek";
var _5 = "VotePostStyle-module__plus-voted___YdgCy";
var _6 = "VotePostStyle-module__plus-voted___YdgCy";
var _7 = "VotePostStyle-module__vote-post___pyO1_";
var _8 = "VotePostStyle-module__vote-post___pyO1_";
var _9 = "VotePostStyle-module__votes___OMY_E";
var _a = "VotePostStyle-module__votes-minus___VQn8I";
var _b = "VotePostStyle-module__votes-plus___oMeAf";
var _c = "VotePostStyle-module__votes-minus___VQn8I";
var _d = "VotePostStyle-module__votes-plus___oMeAf";
export { _1 as "minus", _2 as "minus-voted", _3 as "minusVoted", _4 as "plus", _5 as "plus-voted", _6 as "plusVoted", _7 as "vote-post", _8 as "votePost", _9 as "votes", _a as "votes-minus", _b as "votes-plus", _c as "votesMinus", _d as "votesPlus" }
